import React from 'react';
import PropTypes from 'prop-types';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalTalentContents.scss';
import {
    Grid,
    cls,
    HeaderCompound,
} from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import { vertical } from '../../requests/loader';
import utilsSearch from '../../utils/Search';
import Card from '../CardNew';
import getBadges from '../../utils/Badges';
import Scrollable from '../Scrollable';
import { getBookmark } from '../../requests/loader';
import Device from '../../devices/device';

const MAIN_CLASSNAME = 'aaf-modal-talent-contents';

class ModalTalentContents extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            gridItems: [],
            isLoading: true,
        };
        this.closeModal =this.closeModal.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.keys = Device.getDevice().getKeys();
    }

    closeModal(){
        const { handleClose = ()=>{} } = this.props;
        handleClose();
    }

    getGroupIds(items){
        return items.map(it=>it.id);
    }

    addBookmarkToItems(items, bookmark){
        return items.map(it=>{
            if(bookmark[it.id]){
                it.progress = bookmark[it.id];
            }
            return it;
        })
    }

    parseBookmark(groups){
        const bookmark = {};
        groups.forEach(group=>{
            const {
                vistime: { last: { progress = 0 } = {} } = {}
            } = group;
            bookmark[group.id] = progress;
        });
        return bookmark;
    }

    getGridItems(){
        const { talent, providerIdFromVCard = null } = this.props;
        const {
            fullname,
            id,
            provider_id = ''
        } = talent;
        let providerId = providerIdFromVCard ||  provider_id;
        if(isNaN(providerId)) {
            providerId = '';
        }
        vertical(id, utilsSearch.getSearchField().Talent, providerId).then(items => {
            if(Array.isArray(items) && items.length>0){
                const groupIds = this.getGroupIds(items);
                getBookmark(groupIds.join(',')).then(res =>{
                    if(res && res.response && Array.isArray(res.response.groups)){
                        const bookmarkObj = this.parseBookmark(res.response.groups);
                        const newItems = this.addBookmarkToItems(items,bookmarkObj)
                        this.updateItems(newItems);
                    }
                    else{
                        this.updateItems(items);
                    }
                }).catch(err=>{
                    console.log('getBookmark err',err);
                    this.updateItems(items);
                });
            }
            else{
                this.setState({isLoading:false});
            }
        });
    }

    updateItems(items){
        this.setState({gridItems: items, isLoading: false}, ()=>{
            window.SpatialNavigation.focus(".card-grid");
        })
    }

    componentDidMount(){
        this.getGridItems();
        this.removeEventListener();
        this.addEventListener();
    }

    componentWillUnmount(){
        this.removeEventListener();
    }

    handleKeyDown(e){
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if(currentKey === 'YELLOW'){
            this.closeModal();
        }
    }

    addEventListener(){
        document.addEventListener('keydown', this.handleKeyDown);
    }

    removeEventListener(){
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const modalProps = {
            childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
        };
        const {
            talent: {
                name = '',
                surname = ''
            } ={},
            setMetricsEvent = ()=>{},
            user,
            handleClose =()=>{}
        } = this.props;
        const { gridItems, isLoading } = this.state;
        return (
            <ModalWrapper {...modalProps}>
                <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.closeModal}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Asset.get('top_head_option_back')}`}/>
                        <div className={`${MAIN_CLASSNAME}-talent-name`}>{`${name} ${surname}`}</div>
                    <Scrollable 
                        className={`${MAIN_CLASSNAME}-grid-scrollabe`}>
                        {isLoading ? null : <div className="card-grid">
                            {Array.isArray(gridItems) && gridItems.length>0 && gridItems.map((r, index) =>{
                                const badges = getBadges(
                                    user,
                                    r.proveedor_name,
                                    r.format_types,
                                    r.live_enabled
                                );
                                const cardProps = {
                                    key: index,
                                    index: index,
                                    cover: r.image_small,
                                    group_id: r.group_id || r.id,
                                    title: r.title,
                                    hideInnerTitle: false,
                                    type: 'infinite',
                                    focusable: true,
                                    badges: badges,
                                    provider: r.provider || null,
                                    live_enabled: r.live_enabled || null,
                                    id: r.group_id || r.id || null,
                                    data: r,
                                    onClick: e => {
                                        handleClose();
                                    },
                                    setMetricsEvent: setMetricsEvent,
                                };
                                return (
                                    <Card
                                        {...cardProps}
                                    />
                                )
                            })}
                            {gridItems.length === 0 && <p>{Translator.get('no_content_modal_talent', "Sin contenidos")}</p>}
                        </div>}
                    </Scrollable>
                </Grid>
            </ModalWrapper>
        );
    }
}

ModalTalentContents.defaultProps = {
    talent: {}
};

ModalTalentContents.propTypes = {
    talent: PropTypes.object
};

export default withOnClose(ModalTalentContents);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTalentContents.jsx